import { SET_FEATURE_FLAGS } from "./actionTypes";

export function setFeatureFlags(featureFlags) {
  return {
    type: SET_FEATURE_FLAGS,
    payload: featureFlags,
  };
}
